export enum TimelineGridEventCssVars {
  xPosition = '--x-position',
  width = '--width',
}
